namespace app.directives.charting {
  export enum ValueType {
    Number = 0,
    Bytes = 1,
    Percentage = 2
  }
}
// Expose as browser global so cross-module bare references resolve
(window as any).ValueType = app.directives.charting.ValueType;
